/**
 * กิลด์ศัตรู and ป้ายสังหาร (systems/guildBanner.ts, docs/design/2026-10-14-guild-enemy-banner.md): the numbers of the
 * enemy list and the kill banner, and the simulated hunters of this single-player build. Pure data.
 */
import type { GuildRankId } from './guild';

export const GUILD_BANNER = {
  /** Most guilds on one guild's enemy list. */
  enemiesMax: 5,
  /** Ranks that may declare enemies and raise a banner. */
  raiseRanks: ['leader', 'deputy'] as readonly GuildRankId[],
  /** ตำลึง taken from the guild coffer to raise a banner. */
  cost: 3000,
  /** How long a banner stays up (s of game time). */
  duration: 60 * 60,
  /** Wait after a banner ends before the guild may raise another (s). */
  cooldown: 3 * 60 * 60,
  /** Banners one guild may have up at once. */
  maxActive: 1,
  /** Guild contribution per kill the guild makes under its banner. */
  contributionPerKill: 50,
  /** Offline build: hunters of the other guild who come at the player in the wilds while a banner is up. */
  foesMax: 2,
  /** Seconds between arrivals. */
  foeEvery: 45,
  /** Distance they arrive at (m). */
  foeMin: 14,
  foeMaxDist: 22,
  /** Their strength against the player's (hp and attack factors). */
  foeHp: 0.9,
  foeAtk: 0.8,
  /** Farther than this from the player they give up and leave (m). */
  foeLeave: 40,
} as const;

/** What each side sees over the other's heads while a banner is up (glyphs already in UI_GLYPHS). */
export const GUILD_BANNER_MARKS = {
  /** A member of the guild our banner hunts. */
  hunted: { glyph: '殺', color: '#c8322b', label: 'เป้าป้ายสังหาร' },
  /** A member of a guild whose banner hunts us. */
  hunter: { glyph: '令', color: '#2b2b2b', label: 'ผู้ปักป้ายสังหาร' },
} as const;
export type GuildBannerMark = keyof typeof GUILD_BANNER_MARKS;
